import React, {Component} from 'react';
import Websocket from 'react-websocket';

class WStest extends Component {

    constructor(props) {
        super(props);
        this.state = {
            count: 0
        };

        this.sendMessage = this.sendMessage.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
    }

    handleData(data) {
        let result = JSON.parse(data);
        console.log(result);
        this.setState({count: result});
        setTimeout(() => {
            this.sendMessage(result + 1);
        }, 5000);
    }

    handleOpen()  {
        console.log('opened');
        this.sendMessage(0);
    }

    handleClose() {
        console.log('closed!');
    }

    sendMessage(message){
        this.refWebSocket.sendMessage(message);
    }

    render() {
        return (
            <div>
                Count: <strong>{this.state.count}</strong>

                <Websocket
                    // url='ws://echo.websocket.org'
                    url='ws://localhost:10000/connection/'
                    onMessage={this.handleData.bind(this)}
                    onOpen={this.handleOpen}
                    onClose={this.handleClose}
                    reconnect={true}
                    ref={Websocket => {this.refWebSocket = Websocket}}
                />

            </div>
        );
    }
}

export default WStest;


// WEBPACK FOOTER //
// ./src/ws_test.js